class AccountAddress extends HTMLElement {
    constructor() {
        super();

        this.bindEvents(); 
    }

    bindEvents () {
        const editAddressButtons = this.querySelectorAll(".account__address-edit-button");
        editAddressButtons.forEach((button) => {
            button?.addEventListener("click", this.onEditButtonClick.bind(this));
        })

        const cancelEditButtons = this.querySelectorAll(".account__address-cancel-button");
        cancelEditButtons.forEach((button) => {
            button?.addEventListener("click", this.onEditButtonClick.bind(this));
        })

        const addNewButton = this.querySelector(".account__address-new-button");
        addNewButton?.addEventListener("click", this.onAddNewButtonClick.bind(this))

        const cancleAddButton = this.querySelector(".account__address-new-cancel-button");
        cancleAddButton?.addEventListener("click", this.onAddNewButtonClick.bind(this))
    }

    onAddNewButtonClick(event: Event) {
        const form = this.querySelector("#AddAddress");
        form?.classList.toggle("open");
    }

    onEditButtonClick(event: Event) {
        const target = event.currentTarget as HTMLElement;
        const id = target.getAttribute("data-address-id");
        const editForm = this.querySelector(`#EditAddress_${id}`);

        editForm?.classList.toggle("open");
    }
}

customElements.define("account-address", AccountAddress);
